// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"W8-z","button":"X8-z","disabled":"Y8-z","creditCard":"Z8-z","wrapper":"_8-z"};